export const eShipmentSubTypes: { [key: string]: string } = {
    LCL: 'Less than Container Load',
    FCL: 'Full Container Load',
    FTL: 'Full Truck Load',
    LTL: 'Less than Truck Load',
    SPD: 'Special Delivery',
    BOX: 'Box Shipment',
    CON: 'Container'
};